<!-- @format -->

<div
	class="availability hmf-display-flex hmf-flex-wrap hmf-justify-content-between hmf-align-content-center"
	[class]="showStoreNameInMessage() ? 'no-explicit-height hmf-flex-column' : ''">
	@if (productAvailabilityData() && !isComingSoon() && !isOOS()) {
		<div class="shipping-availability hmf-pb-xxxs">
			<homefield-icon
				height="10px"
				width="10px"
				[class]="shippingMessage()?.class"
				[name]="shippingMessage()?.icon">
			</homefield-icon>
			<span> {{ shippingMessage()?.text }}</span>
		</div>
	}
	@if (selectedStoreName() && !isComingSoon() && !isOOS()) {
		<div class="store-availability hmf-pb-xxxs">
			<homefield-icon
				height="10px"
				width="10px"
				[class]="pickupMessage()?.class"
				[name]="pickupMessage()?.icon">
			</homefield-icon>
			@if (showStoreNameInMessage()) {
				<span> {{ pickupMessage()?.text }} at </span>
				<button
					hmf-action-text
					size="small"
					variant="secondary"
					(click)="clickSelectedStoreName.emit()">
					{{ selectedStoreName() | titlecase }}
				</button>
			} @else {
				<span> {{ pickupMessage()?.text }}</span>
			}
		</div>
	}
</div>
